module.exports = __webpack_public_path__ + "img/pr-41.340f455b.png";